import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";

import "./categoryList.scss";

import CategoryListItem from "../CategoryListItem/categoryListItem";
import Modal from "../Modal/modal";
import { useStore } from "../../store/useStore";
import TransactionItem from "../RecentActivity/Transactions/transactionItem";
import Spinner from "../Spinner/spinner";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import useGetTransactions from "../../hooks/recentActivity/useGetTransactions";
import { END_OF_RESPONSE } from "../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import parse from "html-react-parser";
import { questionMark } from "../../assets/images/icons";
import {
  getMobileOperatingSystem,
  ingestData,
  isMobile,
  isWeb,
} from "../../bridges/BridgeServices";
import useGetOrders from "../../hooks/recentActivity/useGetOrders";
import { Table } from "../Table/table";
import { orderTableConfig } from "../RecentActivity/Orders/orders.constants";
import {
  AUTH_LEVEL,
  EVENTS,
  RECENT_ACTIVITY_TYPES,
} from "../../utils/constants";

const activityTypes = {
  ORDERS: "ORDERS",
  TRANSACTIONS: "TRANSACTIONS",
};

const CategoryList = ({
  pages = [],
  allPagesData = {},
}) => {
  // const [isOpen, setIsOpen] = useState(false);
  // const [currentActivity, setCurrentActivity] = useState(
  //   activityTypes.TRANSACTIONS
  // );

  // const {
  //   transactions,
  //   transactionLoading,
  //   orders,
  //   ordersLoading,
  //   authLevel,
  // } = useStore();

  // const allTransactions = useMemo(() => {
  //   return Object.values(transactions).sort(
  //     (a, b) => b.createdAt - a.createdAt
  //   );
  // }, [transactions]);

  // const nextPageToken = useStore(
  //   state => state.transactionsNextPageToken
  // );
  // const ordersNextPageToken = useStore(
  //   state => state.ordersNextPageToken
  // );

  // const { setTrigger } = useGetTransactions(
  //   Object.values(transactions).length === 0
  // );

  // const getOrders = useGetOrders(true);

  // const targetRef = useIntersectionObserver(
  //   () => {
  //     if (nextPageToken !== END_OF_RESPONSE) {
  //       setTrigger(true);
  //     }
  //   },
  //   { threshold: 0.1 }
  // );

  // useEffect(() => {
  //   if (orders.length > 0) {
  //     setCurrentActivity(activityTypes.ORDERS);
  //   }
  // }, [orders]);

  if (pages.length === 0) {
    return <></>;
  }

  return (
    <div className="category-list-div">
      <div className="category-list-wrapper">
        <div className="category-list-title">Topics</div>
      </div>
      {/* {isWeb() &&
        ((allTransactions && allTransactions.length > 0) ||
          (orders && orders.length > 0)) && (
          <div className="recentActivityContainer">
            <div className="recentActivityHeader">
              {parse(questionMark)}
              {` Need help with an order or transaction?`}
            </div>
            <button
              onClick={() => setIsOpen(true)}
              className="recentActivityCTA"
            >
              VIEW ORDERS/TRANSACTIONS
            </button>
          </div>
        )}
      <Modal
        showModal={isOpen}
        setShowModal={setIsOpen}
        title={"Select Order / transaction"}
        onClose={() => setIsOpen(false)}
        wrapperClassname={
          currentActivity === activityTypes.TRANSACTIONS
            ? "transactionsModal"
            : "ordersModal"
        }
      >
        <div>
          {orders.length > 0 && (
            <button
              onClick={() =>
                setCurrentActivity(activityTypes.ORDERS)
              }
              className={
                currentActivity === activityTypes.ORDERS
                  ? "activeButton"
                  : "inactiveButton"
              }
            >
              {activityTypes.ORDERS}
            </button>
          )}
          {allTransactions.length > 0 && (
            <button
              onClick={() =>
                setCurrentActivity(
                  activityTypes.TRANSACTIONS
                )
              }
              className={
                currentActivity ===
                activityTypes.TRANSACTIONS
                  ? "activeButton"
                  : "inactiveButton"
              }
            >
              {activityTypes.TRANSACTIONS}
            </button>
          )}
          {currentActivity ===
            activityTypes.TRANSACTIONS && (
            <div className="transactionsContainer">
              {allTransactions.map((item, index) => {
                return (
                  <TransactionItem
                    key={index}
                    item={item}
                    lastItem={
                      allTransactions.length - 1 === index
                    }
                    onTransactionClick={() =>
                      ingestData({
                        name:
                          EVENTS.HELP_ACTIVITY_POPUP_CLICKED,
                        data: {
                          source: isMobile()
                            ? getMobileOperatingSystem()
                            : "WEB",
                          type: RECENT_ACTIVITY_TYPES.FUNDS,
                          txnId:
                            item?.data?.globalTransactionId,
                        },
                      })
                    }
                  />
                );
              })}
              {transactionLoading ? (
                <Spinner />
              ) : (
                <div
                  ref={targetRef}
                  style={{ padding: "4px", height: "10px" }}
                ></div>
              )}
            </div>
          )}
          {currentActivity === activityTypes.ORDERS && (
            <div className="">
              <div>
                <Table
                  tableConfig={orderTableConfig.tableConfig}
                  tableData={orders}
                  onRowClick={orderTableConfig?.onRowClick}
                  triggerEndOfPage={() => {
                    if (
                      ordersLoading ||
                      ordersNextPageToken ===
                        END_OF_RESPONSE
                    )
                      return;
                    ordersNextPageToken &&
                      orderTableConfig.triggerEndOfPage(
                        ordersNextPageToken
                      );
                  }}
                />
                {ordersLoading && <Spinner />}
              </div>
            </div>
          )}
        </div>
      </Modal> */}
      <div className="category-list">
        {pages?.map((uri, index) => {
          return (
            <CategoryListItem
              key={uri}
              uri={uri}
              allPagesData={allPagesData}
              lastItem={index === pages?.length - 1}
            />
          );
        })}
      </div>
    </div>
  );
};

CategoryList.propTypes = {
  pages: PropTypes.array,
  allPagesData: PropTypes.object,
};

export default CategoryList;
